module.exports = __webpack_public_path__ + "static/media/scroll-down.f2f39ca5.gif";